import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutComponent } from './about.component';
import { CEOIntroductionComponent } from './ceo-introduction/ceo-introduction.component';
import { AboutHeroComponent } from './about-hero/about-hero.component';
import { SharedModule } from '../shared/shared.module';


const routes: Routes = [
  { path: '', component: AboutComponent },
  { path: 'meet-the-ceo', component: CEOIntroductionComponent }
];

@NgModule({
  declarations: [
    AboutComponent,
    CEOIntroductionComponent,
    AboutHeroComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    SharedModule
  ]
})
export class AboutModule { }
